import { useTheme } from '@mui/material';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Stack,
    Typography,
    Chip,
    Paper,
    Divider,
} from '@mui/material';
import { FlightTakeoff, FlightLand } from '@mui/icons-material';

function getDelayLevel(minutes) {
    if (minutes < 15) return { label: "On Time",     color: "success" };
    if (minutes < 60) return { label: "Minor Delay", color: "warning" };
    return              { label: "Major Delay",  color: "error"   };
}

function PredictResultDialog({ open, onClose, flight, result }) {
    const theme = useTheme();

    if (!result) return null;

    const depLevel = getDelayLevel(result.depDelay);
    const arrLevel = getDelayLevel(result.arrDelay);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Typography variant="subtitle1" fontWeight={600}>Delay Prediction</Typography>
                {flight && (
                    <Typography variant="body2" color="text.secondary">
                        {flight.flightNo} {flight.sector}
                        {flight.flightDate && ` ${new Date(flight.flightDate).toLocaleDateString("en-GB")} `}
                        {flight.std} - {flight.sta}
                    </Typography>
                )}
            </DialogTitle>
            <Divider />
            <DialogContent>
                <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    sx={{ px: 1 }}
                >
                    {[
                        { icon: <FlightTakeoff fontSize="small" color="action" />, label: "Departure", delay: result.depDelay, level: depLevel },
                        { icon: <FlightLand   fontSize="small" color="action" />, label: "Arrival",   delay: result.arrDelay, level: arrLevel },
                    ].map(({ icon, label, delay, level }) => (
                        <Paper
                            key={label}
                            elevation={0}
                            sx={{
                                flex: 1,
                                p: 1.5,
                                border: `1px solid ${theme.palette[level.color].main}`,
                                borderRadius: 2,
                                textAlign: "center",
                            }}
                        >
                            <Stack spacing={1} alignItems="center">
                                <Stack direction="row" spacing={1} alignItems="center">
                                    {icon}
                                    <Typography variant="body2" color="text.secondary">{label}</Typography>
                                    <Chip size="small" label={level.label} color={level.color} sx={{ fontWeight: 600 }} />
                                </Stack>
                                <Stack direction="row" spacing={0.5} alignItems="baseline">
                                    <Typography
                                        fontWeight={600}
                                        color={`${level.color}.main`}
                                        sx={{ fontSize: "1.5rem", lineHeight: 1 }}
                                    >
                                        {delay}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">min</Typography>
                                </Stack>
                            </Stack>
                        </Paper>
                    ))}
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="secondary" onClick={onClose}>
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default PredictResultDialog;
